import { SET_SUPPORT_MEMBER } from "./action";

const initialState = { supportMember: {} };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SUPPORT_MEMBER:
      return { ...state, supportMember: action.payload };
    default:
      return state;
  }
};

export default reducer;
